<template>
  <div class="sponsorship_box_container"
  :class="$mq"
  >

    <h6>This contest sponsored by:</h6>
    
    <div class="container">
      <div class="row">
        <div class="col-12">

          <div class="row">
            <div class="col-4"
            v-for="(sponsor, index) in sponsors"
            :key="`sponsor_`+index"
            >
              
              <div class="sponsor_box">
                
                <a :href="sponsor.website_url" target="_blank"
                @click="sponsor_click(sponsor, $event)"
                >
                
                  <div class="sponsor_image_container">
                    <img :src="resize_cms_image(sponsor.logo_url)" :alt="sponsor.name">
                  </div>

                  <span class="sponsor_name">{{sponsor.name}}</span>
                </a>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    

  </div>
</template>

<script>
import CardGeneric from '@/components/cards/card_generic.vue'

export default {
  name: 'sponsorship_box',
  props: [
    'title',
    'sponsors'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    resize_cms_image: function(value) {
      if(value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      }
      else {
        return value;
      }
    },
    sponsor_click: function(sponsor, e) {
      let vm = this;
      
      // FIRE GA EVENT
      vm.$ga.event({
        eventCategory: 'Sponsors',
        eventAction: 'click',
        eventLabel: sponsor.name
      })
    }
  },
  components: {
    CardGeneric
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.sponsorship_box_container {

  background: #efefef;
  border-top: solid 1px #ccc;
  border-bottom: solid 1px #ccc;

  h6 {
    margin-bottom: 1em;
    font-weight: normal;
    font-size: 0.9em;
    text-align: center;
    padding: 0.5em 0;
    background: #dedede;
    border-bottom: solid 4px #ccc;
  }

  .sponsor_box {

    width: 100%;
    height: 160px;
    display: block;
    overflow: hidden;

    .sponsor_image_container {
      display: block;
      width: 100%;
      margin-bottom: 0.4em;
      height: 95px;

      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }

    }

    .sponsor_name {
      display: block;
      width: 100%;
      text-align: center;
      line-height: 1em;
      font-size: 0.9rem;
    }

    a {
      color: blue;

      &:hover {
        color: blue;
      }
    }

  }

  &.desktop, &.laptop {

    h6 {
      font-size: 1.1em;
    }

    .sponsor_box {
      height: 180px;
    }

    .sponsor_name {
      font-size: 1.2em;
      line-height: 1.2em;
    }

    .sponsor_image_container {
      height: 120px;
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/features/sponsorships/sponsorship_box.vue